import { keyBy } from '@exodus/basic-utils';
import { atom } from '@exodus/headless-ui';
import fromAssetAtom from './from-asset.js';
import toWalletAccountAtom from './to-wallet-account.js';
const toAssetsNamesAtom = atom((get, { selectors }) => {
    const assetsByWalletAccount = get(selectors.assetSources.availableAssetNamesByWalletAccount);
    const toWalletAccount = get(toWalletAccountAtom);
    return new Set(assetsByWalletAccount[toWalletAccount.toString()] ?? []);
});
const toAssetsAtom = atom(async (get, { selectors, exodus }) => {
    const fromAsset = get(fromAssetAtom);
    const allAssets = get(selectors.assets.all);
    const toAssetsNames = get(toAssetsNamesAtom);
    const enabledAssets = [...toAssetsNames]
        .map((assetName) => allAssets[assetName])
        .filter((asset) => !!asset);
    const assetsByTicker = keyBy(enabledAssets, 'ticker');
    const supportedIds = await exodus.exchange.getSupportedToAssetIds(fromAsset.ticker);
    return supportedIds.map((id) => assetsByTicker[id]).filter((asset) => !!asset);
});
export default toAssetsAtom;
